(() => {
  const selector = '[data-fashion-variant-price]';

  function update(root, variantId) {
    if (!root || !variantId) return;

    let variants;
    try {
      variants = JSON.parse(root.dataset.variantPrices || '[]');
    } catch {
      return;
    }

    const variant = variants.find((item) => String(item.id) === String(variantId));
    if (!variant) return;

    const current = root.querySelector('[data-fashion-current-price]');
    const row = root.querySelector('[data-fashion-compare-line]');
    const compare = root.querySelector('[data-fashion-compare-price]');
    const save = root.querySelector('[data-fashion-save]');
    if (current) current.textContent = variant.price;

    const onSale = Boolean(variant.compare && variant.save && variant.percent != null);
    if (row) row.hidden = !onSale;
    if (onSale) {
      if (compare) compare.textContent = variant.compare;
      if (save) save.textContent = `You save ${variant.save} (${variant.percent}%)`;
    }
    root.dataset.currentVariant = String(variant.id);
  }

  function updateFromInput(input) {
    const productInfo = input.closest('product-info');
    const root = productInfo?.querySelector(selector);
    update(root, input.value);
  }

  function initialize(root = document) {
    root.querySelectorAll?.(selector).forEach((price) => {
      update(price, price.dataset.currentVariant);
    });
  }

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (input instanceof HTMLInputElement && input.name === 'id') updateFromInput(input);
  });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }
})();
